import { defineView } from "foldkit/submodel";

import { i18next } from "../../i18n";
import * as AiChat from "../../widgets/aiChat";
import type { Shared } from "../shared";
import { Message } from "./message";
import type { Model } from "./model";
import { aiTurnedOff } from "./update";

/** v1 `Chat.tsx`: heading, description, and the chat widget in a card. */
export const view = defineView<Model, Message, Shared>((model, shared, h) =>
	h.div(
		[
			h.DataAttribute("testid", "page-Chat"),
			h.Class("flex flex-col px-4 pt-8"),
		],
		[
			h.div(
				[h.Class("mx-auto flex w-full max-w-4xl flex-col gap-4")],
				[
					h.div(
						[h.Class("space-y-1")],
						[
							h.h1(
								[h.Class("text-xl font-semibold text-base-content")],
								[i18next.t("chat.title")],
							),
							h.p(
								[h.Class("text-sm text-base-content/70")],
								[i18next.t("chat.description")],
							),
						],
					),
					aiTurnedOff(model)
						? h.div(
								[h.Role("status"), h.Class("alert")],
								[
									h.span([], [i18next.t("settings.ai.refused")]),
									h.a(
										[
											h.Href("/settings"),
											h.Class("btn btn-sm"),
											h.AriaLabel(i18next.t("settings.ai.openSettings")),
										],
										[i18next.t("settings.ai.openSettings")],
									),
								],
							)
						: h.div(
								[h.Class("card rounded-xl bg-base-100 shadow min-h-[70vh]")],
								[
									h.div(
										[h.Class("card-body flex h-full p-0")],
										[
											h.submodel({
												slotId: "ai-chat",
												view: AiChat.view,
												model: model.chat,
												viewInputs: shared,
												toParentMessage: (message: AiChat.Message) =>
													Message.GotChatMessage({ message }),
											}),
										],
									),
								],
							),
				],
			),
		],
	),
);
